/**
 * Single source of values: `authLoginDefaults.json`.
 *
 * - Frontend / Vite: `@merlot/common/authLoginDefaults.js`
 * - Backend CommonJS: `require('.../common/authLoginDefaults.json')`
 *
 * Used by User schema `login`, admin create validators, and UserForm.
 * Keep `pattern` quantifier in sync with `minLength` / `maxLength`.
 */

import data from './authLoginDefaults.json' assert { type: 'json' };

export const AUTH_LOGIN_MIN_LENGTH = data.minLength;
export const AUTH_LOGIN_MAX_LENGTH = data.maxLength;
export const AUTH_LOGIN_PATTERN = data.pattern;
